var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.83333C2.5 7.675 5.85833 9.16667 10 9.16667C14.1417 9.16667 17.5 7.675 17.5 5.83333M2.5 5.83333C2.5 3.99167 5.85833 2.5 10 2.5C14.1417 2.5 17.5 3.99167 17.5 5.83333M2.5 5.83333L2.5 10M17.5 5.83333L17.5 10M2.5 10C2.5 11.8417 5.85833 13.3333 10 13.3333C14.1417 13.3333 17.5 11.8417 17.5 10M2.5 10L2.5 14.1667C2.5 16.0083 5.85833 17.5 10 17.5C14.1417 17.5 17.5 16.0083 17.5 14.1667V10",
    stroke: "#161616",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCredit);
export default __webpack_public_path__ + "static/media/Icn_credit.c9421ec18eab3f0f676a9b678e55a99a.svg";
export { ForwardRef as ReactComponent };